import { combineReducers } from 'redux';
import chartsPage from '../../pages/ProjectsPage/reducers/projectsPageReducer.js';
import profile from '../../redux/reducers/profileReducer';
import packagesPage from '../../pages/PackagesPage/reducers/PackagesPage';

export default combineReducers({
  chartsPage,
  packagesPage,
  profile
});
